<script type="text/javascript">
	import Multiselect from 'vue-multiselect'
	export default{
		data() {
			return{
				storageurl: '.s3.eu-west-2.amazonaws.com',
				success_message: false,
      			success_messagetext: 'Congratulations, your action was successful',
      			error_reponse: '',
      			error_message: false,
				loadingForm: false,
				products: [],
				productsearch: '',
				status: 1,
				supportStatuses: [{text: "Awaiting Receipt", value: 1},{text: "Awaiting Seller Response", value: 2},{text: "In Progress", value: 3},{text: "Resolved", value: 4},{text: "Completed", value: 5},{text: "Archived", value: 6}],
				contactOptions: [
					{icon: 'bx bx-mail-send', text: "SMS", value: 'SMS'},
					{icon: 'bx bx-chat', text: 'Chat', value: 'chat'},
					{icon: 'bx bxl-whatsapp', text: "WhatsApp", value: 'whatsapp'}
				],
				support_type: '',
				support_order: '',
				support_order_company_id: '',
				support_company_order: '',
				support_company_order_product: '',
				support_product: '',
				support_proudct_company: '',
				support_contact: '',
				support_types: [
					{
						text: 'Order Enquiry', value: 'order'
					},
					{
						text: 'Order Cancellation', value: 'cancellation'
					},
					{
						text: 'Delivery Issue', value: 'delivery'
					},
					{
						text: 'Product Enquiry', value: 'product'
					}
				],
				support_contact_options: [
					{
						text: 'Email', value: 'email', disabled: false,
					},
					{
						text: 'Phone', value: 'phone', disabled: false,
					},
					{
						text: 'Chat', value: 'chat', disabled: true,
					},
					{
						text: 'SMS', value: 'sms', disabled: true,
					},
					{
						text: 'WhatsApp', value: 'whatsapp', disabled: true,
					},
				]
			}
		},
		components: { Multiselect },
		props: {
			token: {
				type: Object
			},
			user: {
				type: Object
			},
			from: {
				type: Object,
				default: 'customer'
			},
			orders: {
				type: Object,
			}
		},
		mounted(){
			this.recaptcha();
		},
		methods: {
			loadSupportOptions(){
				this.$emit('load-orders');
			},
			async recaptcha() {
     			 // (optional) Wait until recaptcha has been loaded.
		      await this.$recaptchaLoaded()

		      // Execute reCAPTCHA with action "login".
		      const token = await this.$recaptcha('login');
		      document.getElementById('recaptcha').value = token;
		      // Do stuff with the received token.
		    
		    },
		    searchOrders(){

		    },
		    searchProduct(){
		    	axios.get('/customer-api/user/message/product-search?search='+this.productsearch, {headers: {
		    		'Authorization' : 'Bearer '+this.user.api_token
		    	}}).then(response => {
		    		this.products = response.data;
		    	}).catch(error => {

		    	});
		    },
			sendEnquiry(){
				
				//var notspam = this.recaptcha();
				this.loadingForm = true;
				var postForm = new FormData(document.getElementById("contact-form"));
				postForm.append('support_type', this.support_type);
				if(this.support_order !== ''){
					postForm.append('support_order', this.support_order.id);
				}
				if(this.support_company_order !== ''){
					postForm.append('support_company_order', this.support_company_order.id);
					postForm.append('support_order_company_id', this.support_company_order.company_id);
				}
				if(this.support_company_order_product !== ''){
					postForm.append('support_company_order_product', this.support_company_order_product.id);
				}
				if(this.support_product !== ''){
					postForm.append('support_product', this.support_product.id);
				}
				if(this.support_product_order !== ''){
					postForm.append('support_proudct_company', this.support_proudct_company.company_id);
				}
				postForm.append('status', this.status);
				postForm.append('support_contact', this.support_contact);
				axios.post('/customer-api/user/message/create', postForm, {
					headers: {
						'Authorization' : 'Bearer '+this.user.api_token
					}
				}).then(response => {
					this.success_message = true; 
					this.success_messagetext = 'Your support message has been sent';
					let self = this
					setTimeout(function() {
						self.loadingForm = false;
					}, 300);
				}).catch(error => {
                	this.error_reponse = error.response.data.errors;
					this.error_message = true;
					let self = this
					setTimeout(function() {
						self.loadingForm = false;
					}, 300);
				});
			},
		}
	}
</script>

<template>
	<b-overlay :show="loadingForm">
		<b-card class="border-radius-1em border shadow-none">
			<transition name="slide-success" mode="out-in">
                  <b-alert id="success-message" variant="success" :show="success_message"  dismissible @dismissed="success_message = !success_message">
                      <p class="font-size-14">{{success_messagetext}}</p>
                    </b-alert>
                  </transition>

      <transition name="slide-error" mode="out-in">
                    <b-alert id="errors" variant="danger" :show="error_message == true"  dismissible @dismissed="error_message = !error_message">
                      <p class="font-size-14">Oops! Please correct the following errors in your submission</p>
                      <ul>
                        <li v-for="(error, key) in error_reponse">
                          {{error[0]}}
                        </li>
                      </ul>
                    </b-alert>
                    
                  </transition>
		  <b-form id="contact-form" >
		  	<input type="hidden" name="recaptcha" id="recaptcha">
		  	<input type="hidden" name="paremt_id" id="paremt_id">
		  	<input type="hidden" name="customer_id" id="customer_id" v-model="user.id">
		  	<input type="hidden" name="from" id="from" v-model="from">
		  	<b-row>
		  		<b-col md="12">
		  			<h3>Contact Information</h3>
		  		</b-col>
		  		<b-col>
			    	<b-form-group label="Name">
			    		<b-form-input name="name" class="underline-input my-2" placeholder="First Name" type="text" disabled v-model="user.name"></b-form-input>
			    		<input type="hidden" name="name" v-model="user.name">
			    	</b-form-group>
		    	</b-col>
			    <b-col>
			    	<b-form-group label="Last name">
			    		<b-form-input name="lastname" class="underline-input my-2" placeholder="Last Name" type="text" disabled v-model="user.lastname"></b-form-input>
			    		<input type="hidden" name="lastname" v-model="user.lastname">
			    	</b-form-group>
			    </b-col>
	    	</b-row>
	    	<b-row>
				<b-col md="12">
			    	<b-form-group label="Email Address">
			    		<b-form-input name="email" class="underline-input my-2" placeholder="Email" type="text" disabled v-model="user.email"></b-form-input>
			    		<input type="hidden" name="email" v-model="user.email">
			    	</b-form-group>
			    </b-col>
			    <b-col>
			    	<b-form-group label="Telephone">
			    		<b-form-input name="telephone" class="underline-input my-2" placeholder="Telephone" type="text"></b-form-input>
			    	</b-form-group>
			    </b-col>
			    <b-col>
			    	<b-form-group label="Mobile Phone">
			    		<b-form-input name="mobile" class="underline-input my-2" placeholder="Mobile Phone" type="text"></b-form-input>
			    	</b-form-group>
			    </b-col>
			</b-row>
			<!--<b-card class="border-radius-1em border shadow-none">
				<b-form-group label="Contact Preferences" >
      				<b-form-checkbox-group 
      				class="d-inline-flex w-100 justify-content-between"
      				v-model="support_contact"
      				:options="support_contact_options"
      			
      				>
      				</b-form-checkbox-group>
      			</b-form-group>
			</b-card>-->
			<h3 class="mt-4">Enquiry Details</h3>
	    	<b-form-group label="Query Type">
	    	<b-form-select :options="support_types" name="query_type" class="form-control" v-model="support_type" @input="loadSupportOptions()">
	    	</b-form-select>
	    	</b-form-group>
	    	<b-form-group v-if="((support_type == 'order') || (support_type == 'cancellation') || (support_type == 'delivery')) && orders.length > 0" label="Select Order:" class="mt-3">
	    		<multiselect v-if="((support_type == 'order') || (support_type == 'cancellation') || (support_type == 'delivery')) && orders.length > 0" v-model="support_order" track-by="reference" label="reference" :options="orders" :option-height="104" class="underline-select" >
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100">
                     <div class="avatar-xs mr-4 my-auto" v-if="(support == 'order' || support == 'cancellation') && orders.length > 0" >
                        <span class="avatar-title rounded-circle" >{{(option.reference).slice(0,2)}}</span>
                       
                      </div>
                      <div class="option__desc d-flex flex-row flex-grow-1"><span class="option__title ml-2 my-auto w-100">{{ option.reference }}</span>
                      	<span v-else class="option__title my-auto w-100">Select Order</span>

                      </div>
                      <div class="avatar-xs my-auto" v-if="support_order == ''">
                      <span class="avatar-title rounded-circle bg-light text-primary"><i class="bx bx-chevron-down"></i></span>
                  	 </div>

                      </div></template>-->
                      <template slot="singleLabel" slot-scope="{ option }">
                      <div class="d-flex w-100"><div class="avatar-xs mr-1">
                                        <span class="avatar-title rounded-circle">{{(option.reference).slice(0,2)}}</span>
                                      </div>
                      <div class="option__desc d-flex flex-row w-100"><span class="option__title ml-2 my-auto w-100 px-2">		<span class="badge badge-light bg-light text-dark mr-3">{{option.created_at | luxon({input: 'server'})}}</span>
{{ option.reference }}  </span>
                      	
                      	
                      </div>
                      </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="d-flex w-100"><div class="avatar-xs mr-1">
                                        <span class="avatar-title rounded-circle">{{(option.reference).slice(0,2)}}</span>
                                      </div>
                      <div class="option__desc d-flex flex-row w-75"><span class="option__title ml-2 my-auto w-100">	<span class="badge badge-light bg-light text-dark mr-3">{{option.created_at | luxon({input: 'server'})}}</span> {{ option.reference }} </span>
                      
                      	
                      </div>
                      </div>
                    </template>
                     <template slot="afterList" slot-scope="{ option }" v-if="$attrs.orderlast_page > 1" >
                    	<a class="btn btn-light btn-block" @click="$emit('updateorderslist')" >
                    		Load More Items
                    	</a>
                    </template>
                  </multiselect>
	    	</b-form-group>
	    	 	<b-form-group v-if="((support_type == 'order') || (support_type == 'cancellation') || (support_type == 'delivery')) && support_order !== ''" label="Select Company:" class="mt-3">
	    	<multiselect v-if="((support_type == 'order') || (support_type == 'cancellation') || (support_type == 'delivery'))  && support_order !== ''" v-model="support_company_order" track-by="reference" label="reference" :options="support_order.company_order" :option-height="104" class="underline-select" >
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100">
                     <div class="avatar-xs mr-1 my-auto" v-if="(support == 'order' || support == 'cancellation') && orders.length > 0" >
                        <span class="avatar-title rounded-circle" >{{(option.reference).slice(0,2)}}</span>
                       
                      </div>
                      <div class="option__desc d-flex flex-row flex-grow-1"><span class="option__title ml-2 my-auto w-100">{{ option.reference }}</span>
                      	<span v-else class="option__title my-auto w-100">Select Order</span>

                      </div>
                      <div class="avatar-xs my-auto" v-if="support_order == ''">
                      <span class="avatar-title rounded-circle bg-light text-primary"><i class="bx bx-chevron-down"></i></span>
                  	 </div>

                      </div></template>-->
                      <template slot="singleLabel" slot-scope="{ option }">
                      <div class="d-flex"><div class="avatar-xs mr-1" v-if="option.company_order.company.logo == null">
                                        <span class="avatar-title rounded-circle">{{(option.company_order.company.name).slice(0,2)}}</span>
                                      </div>
                                      <img v-else :src="'https://'+option.company_order.company.nickname + storageurl + option.company_order.company.logo" class="avatar-xs mr-1 border rounded-circle">
                      <div class="option__desc d-flex flex-row"><span class="option__title ml-2 my-auto w-100 px-2">{{ option.company_order.company.name }}</span>
                      	
                      </div>
                      </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="d-flex"><div class="avatar-xs mr-1" v-if="option.company_order.company.logo == null">
                                        <span class="avatar-title rounded-circle">{{(option.company_order.company.name).slice(0,2)}}</span>
                                      </div>
                                      <img v-else :src="'https://'+option.company_order.company.nickname + storageurl + option.company_order.company.logo" class="avatar-xs mr-1 border rounded-circle">
                      <div class="option__desc d-flex flex-row"><span class="option__title ml-2 my-auto w-100 px-2">{{ option.company_order.company.name }}</span>
                      	
                      </div>
                      </div>
                    </template>
                    <!--<template slot="afterList" slot-scope="{ option }">
                    	<a class="btn btn-light btn-block">
                    		Load More Items
                    	</a>
                    </template>-->
                  </multiselect>
	    	</b-form-group>
	    	<b-form-group v-if="(support_type == 'order') && support_company_order !== ''" label="Select Item:" class="mt-3">
	    	<multiselect v-if="(support_type == 'order') && support_company_order !== ''" v-model="support_company_order_product" track-by="reference" label="reference" :options="support_company_order.company_order.products" :option-height="104" class="underline-select" >
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100">
                     <div class="avatar-xs mr-1 my-auto" v-if="(support == 'order' || support == 'cancellation') && orders.length > 0" >
                        <span class="avatar-title rounded-circle" >{{(option.reference).slice(0,2)}}</span>
                       
                      </div>
                      <div class="option__desc d-flex flex-row flex-grow-1"><span class="option__title ml-2 my-auto w-100">{{ option.reference }}</span>
                      	<span v-else class="option__title my-auto w-100">Select Order</span>

                      </div>
                      <div class="avatar-xs my-auto" v-if="support_order == ''">
                      <span class="avatar-title rounded-circle bg-light text-primary"><i class="bx bx-chevron-down"></i></span>
                  	 </div>

                      </div></template>-->
                      <template slot="singleLabel" slot-scope="{ option }">
                      <div class="d-flex"><div class="avatar-xs mr-1" v-if="option.product.cover_image == null">
                                        <span class="avatar-title rounded-circle">{{(option.product.name).slice(0,2)}}</span>
                                      </div>
                                       <img v-else-if="'thumb' in option.product.cover_image" :src="'https://' + support_company_order.company_order.company.nickname + storageurl+option.product.cover_image.thumb" class="avatar-xs mr-1 border rounded-circle">
                                      <img v-else-if="'gallery' in option.product.cover_image" :src="'https://' + support_company_order.company_order.company.nickname + storageurl+option.product.cover_image.gallery" class="avatar-xs mr-1 border rounded-circle">
                                      <img v-else-if="'src' in option.product.cover_image" :src="'https://' + support_company_order.company_order.company.nickname + storageurl+option.product.cover_image.src" class="avatar-xs mr-1 border rounded-circle">
                      <div class="option__desc d-flex flex-row"><span class="option__title ml-2 my-auto w-100 px-2">	<span class="badge badge-primary bg-primary mr-3">{{option.product.reference}}</span> {{ option.product.name }}</span>
                      	
                      </div>
                      </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="d-flex"><div class="avatar-xs mr-1" v-if="option.product.cover_image == null">
                                        <span class="avatar-title rounded-circle">{{(option.product.name).slice(0,2)}}</span>
                                      </div>
                                      <img v-else-if="'thumb' in option.product.cover_image" :src="'https://' + support_company_order.company_order.company.nickname + storageurl+option.product.cover_image.thumb" class="avatar-xs mr-1 border rounded-circle">
                                      <img v-else-if="'gallery' in option.product.cover_image" :src="'https://' + support_company_order.company_order.company.nickname + storageurl+option.product.cover_image.gallery" class="avatar-xs mr-1 border rounded-circle">
                                      <img v-else-if="'src' in option.product.cover_image" :src="'https://' + support_company_order.company_order.company.nickname + storageurl+option.product.cover_image.src" class="avatar-xs mr-1 border rounded-circle">
                      <div class="option__desc d-flex flex-row"><span class="option__title ml-2 my-auto w-100 px-2">	<span class="badge badge-primary bg-primary mr-3">{{option.product.reference}}</span> {{ option.product.name }}</span>
                      	
                      </div>
                      </div>
                    </template>
                    <!--<template slot="afterList" slot-scope="{ option }">
                    	<a class="btn btn-light btn-block">
                    		Load More Items
                    	</a>
                    </template>-->
                  </multiselect>
	    	</b-form-group>
	    	<div class="mt-sm-0 form-inline w-100 mt-2" v-if="support_type == 'product'" >
              <div class="search-box mr-2 ml-auto d-flex">
                <div class="position-relative w-100">
                  <input
                    type="text"
                    class="form-control w-100 border"
                    placeholder="Search reference..."
                    v-model="productsearch"
                    @keyup.enter="searchProduct()"
                  />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
                <transition name="fade-right">
                 <a v-if="productsearch.length > 3" class="btn btn-primary btn-rounded" @click="searchProduct()">
              	Search
              </a>
            </transition>
              </div>
             
            </div>

          <b-list-group v-if="support_product == ''" class="mt-3">
          	<b-list-group-item v-for="product in products" class="d-flex">
          		<div class="avatar-xs mr-2 my-auto" v-if="product.cover_image == null">
                           <span class="avatar-title rounded-circle">{{(product.name).slice(0,2)}}</span>
										</div>
										<img v-else-if="'thumb' in product.cover_image" :src="storageurl+product.cover_image.thumb" class="avatar-xs mr-2 border rounded-circle my-auto">
										<img v-else-if="'gallery' in product.cover_image" :src="storageurl+product.cover_image.gallery" class="avatar-xs mr-2 border rounded-circle my-auto">
										<img v-else-if="'src' in product.cover_image" :src="storageurl+product.cover_image.src" class="avatar-xs mr-2 border rounded-circle my-auto">
          		 <p class="my-auto mr-auto">
          		 	<span class="badge badge-light bg-light text-dark">
          		 		{{product.reference}}
          		 	</span>
          		 {{product.name}}</p>
          		 <a class="btn btn-primary btn-rounded my-auto" @click="support_product = product, support_product_company = product.company">
          		 	<i class="mdi mdi-plus"></i>
          		 </a>
          	</b-list-group-item>
          </b-list-group>
          <b-card class="border-radius-1em border shadow-none mt-3" body-class="d-flex" v-else>
          	<div class="avatar-sm mr-4 my-auto" v-if="support_product.cover_image == null">
                           <span class="avatar-title rounded-circle">{{(support_product.name).slice(0,2)}}</span>
										</div>
										<img v-else-if="'thumb' in support_product.cover_image" :src="storageurl+support_product.cover_image.thumb" class="avatar-sm mr-4 border rounded-circle my-auto">
										<img v-else-if="'gallery' in support_product.cover_image" :src="storageurl+support_product.cover_image.gallery" class="avatar-sm mr-4 border rounded-circle my-auto">
										<img v-else-if="'src' in support_product.cover_image" :src="storageurl+support_product.cover_image.src" class="avatar-sm mr-4 border rounded-circle my-auto">
          		 <p class="my-auto mr-auto">
          		 	<span class="badge badge-primary bg-primary">
          		 		{{support_product.reference}}
          		 	</span>
          		 {{support_product.name}}</p>
          		 <a class="btn btn-primary btn-rounded my-auto" @click="support_product = '', support_product_company = ''">
          		 	<i class="mdi mdi-close"></i>
          		 </a>
          </b-card>
	    	<b-form-group label="Subject" class="mt-2">
	    		<b-form-input name="subject" class="underline-input my-2" placeholder="Subject" type="text"></b-form-input>
	    	</b-form-group>
	    	<b-form-group label="Message">
	    		<b-form-textarea
	    		class="underline-input my-2"
			      id="textarea"
			      placeholder="Enter something..."
			      rows="4"
			      name="message"
			    ></b-form-textarea>
	    	</b-form-group>
	    	<b-button variant="primary" class="btn-rounded btn-block mt-3" @click="sendEnquiry()">Send Message</b-button>
	    </b-form>
	</b-card>
	</b-overlay>
</template>